import { render, staticRenderFns } from "./PushNotificationsEditPopup.vue?vue&type=template&id=48fdb723&"
import script from "./PushNotificationsEditPopup.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationsEditPopup.vue?vue&type=style&index=0&id=48fdb723&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports